<template>
  <!-- 小轮播图  高度90px -->
  <div class='swiper-small-container' v-if='floorData.data.length > 0'>
    <van-swipe class='van-swipe' :show-indicators='false' :autoplay='3000'>
      <van-swipe-item v-for='(item, index) in floorData.data' :key='index'>
        <img
          v-if='item.imageUrl'
          v-lazy='item.imageUrl'
          @click="$jumpToPage(item)"
          alt='' />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: 'Swiper',
  data: () => {
    return {}
  },
  props: ['floorData'],
  methods: {
    gotoUrl(item) {
      if (item.titleUrl) {
        location.href = item.titleUrl
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.swiper-small-container {
  padding: 0 0.1rem;

  .van-swipe {
    height: 0.45rem;
    border-radius: 5px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
